import {ResourceRight} from './resource-right.model';

export class Role {
  id: number;
  name: string;
  resourceRights: ResourceRight[];

  constructor(id: number, name: string, resourceRights: ResourceRight[]) {
    this.id = id;
    this.name = name;
    this.resourceRights = resourceRights;
  }
}
